export default __webpack_public_path__ + "static/media/VEB_criticalIllness.468b8af0.png";